import { render, staticRenderFns } from "./IdeasContent.vue?vue&type=template&id=55e6fed3&"
import script from "./IdeasContent.vue?vue&type=script&lang=js&"
export * from "./IdeasContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports